import React from "react";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import Divider from "@mui/material/Divider";
import DatabasePicker from "../other/StartRunDatabasePicker";

const classes = {
    instruction: css`
        margin: 10px 0;
        font-weight: bold;
    `,
    divider: css`
        margin: 10px 0;
    `,
};

const SelectSurveyDatabase = (props) => {
    const { t } = useTranslation();

    return (
        <div>
            <div className={classes.instruction}>1a. {t("Select survey database")}</div>

            <DatabasePicker
                databaseType={props.surveyDatabaseType}
                defaultDatabases={props.defaultDatabases}
                customDatabases={props.customDatabases}
                selectedDatabaseId={props.selectedSurveyDatabaseId}
                uploadedDatabaseName={props.uploadedSurveyDatabaseName}
                databaseUploadProgress={props.surveyDatabaseUploadProgress}
                uploadingDatabase={props.uploadingSurveyDatabase}
                onChangeDatabaseType={props.onChangeSurveyDatabaseType}
                onSelectDatabase={props.onSelectSurveyDatabase}
                onSelectDatabaseFile={props.onSelectSurveyDatabaseFile}
                onUploadDatabase={props.onUploadSurveyDatabase}
                onCancelDatabaseUpload={props.onCancelSurveyDatabaseUpload}
            />

            <Divider className={classes.divider} />
        </div>
    );
};

export default SelectSurveyDatabase;
